import React, { Component, Fragment } from "react";
import { Card, Message } from "semantic-ui-react";
import Editor, { composeDecorators } from "draft-js-plugins-editor";
// import createInlineToolbarPlugin from "draft-js-inline-toolbar-plugin";
import createToolbarPlugin, { Separator } from "draft-js-static-toolbar-plugin";
import createImagePlugin from "draft-js-image-plugin";
import createAlignmentPlugin from "draft-js-alignment-plugin";
import createFocusPlugin from "draft-js-focus-plugin";
import createResizeablePlugin from "draft-js-resizeable-plugin";
import createBlockDndPlugin from "draft-js-drag-n-drop-plugin";
import createEmojiPlugin from "draft-js-emoji-plugin";

import "draft-js-emoji-plugin/lib/plugin.css";
import "draft-js-image-plugin/lib/plugin.css";
import "draft-js-alignment-plugin/lib/plugin.css";
// import "draft-js-resizeable-plugin/lib/plugin.css";
import "draft-js-focus-plugin/lib/plugin.css";
// import "draft-js-resizeable-plugin/lib/plugin.css";
// import "draft-js-drag-n-drop-plugin/lib/plugin.css";
// import "draft-js-inline-toolbar-plugin/lib/plugin.css";

import {
  ImagePickerButton,
  ItalicButton,
  BoldButton,
  UnderlineButton,
  UnorderedListButton,
  OrderedListButton,
  BlockQuoteButton,
  HeaderOneButton,
  HeaderTwoButton,
  HeaderThreeButton,
  LinkButton
} from "./EditorButtons";

// const inlineToolbarPlugin = createInlineToolbarPlugin();
const toolbarPlugin = createToolbarPlugin();

const focusPlugin = createFocusPlugin();
const resizeablePlugin = createResizeablePlugin();
const alignmentPlugin = createAlignmentPlugin();
const blockDndPlugin = createBlockDndPlugin();
const emojiPlugin = createEmojiPlugin();

const composedPluginDecorators = composeDecorators(
  resizeablePlugin.decorator,
  alignmentPlugin.decorator,
  focusPlugin.decorator,
  blockDndPlugin.decorator
);

export const imagePlugin = createImagePlugin({
  decorator: composedPluginDecorators
});

const { EmojiSuggestions } = emojiPlugin;
// const { InlineToolbar } = inlineToolbarPlugin;
const { Toolbar } = toolbarPlugin;
const { AlignmentTool } = alignmentPlugin;

const plugins = [
  toolbarPlugin,
  emojiPlugin,
  blockDndPlugin,
  focusPlugin,
  alignmentPlugin,
  resizeablePlugin,
  imagePlugin
];

const styleMap = {
  LINK: {
    color: "#4990e1"
  }
};
export default class ContentEditor extends Component {
  focus = () => this.editor.focus();
  onChange = editorState => {
    this.props.handleEditorChange(editorState);
  };
  render() {
    return (
      <div>
        <Toolbar>
          {externalProps => {
            return (
              <Message>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "1rem, 2rem"
                  }}
                >
                  <BoldButton {...externalProps} />
                  <ItalicButton {...externalProps} />
                  <UnderlineButton {...externalProps} />
                  <HeaderOneButton {...externalProps} />
                  <HeaderTwoButton {...externalProps} />
                  <HeaderThreeButton {...externalProps} />
                  <UnorderedListButton {...externalProps} />
                  <OrderedListButton {...externalProps} />
                  <BlockQuoteButton {...externalProps} />
                  <ImagePickerButton {...externalProps} />
                  <LinkButton {...externalProps} />
                </div>
              </Message>
            );
          }}
        </Toolbar>
        <div
          onClick={this.focus}
          style={{ maxHeight: "84vh", overflow: "auto" }}
        >
          <Editor
            placeholder={
              <p
                style={{
                  color: "rgba(191, 191, 191, 0.87)",
                  paddingTop: "1em"
                }}
              >
                Add content body...
              </p>
            }
            spellCheck={true}
            customStyleMap={styleMap}
            editorState={this.props.editorState}
            onChange={this.onChange}
            plugins={plugins}
            ref={element => {
              this.editor = element;
            }}
          />
          <AlignmentTool />
          <EmojiSuggestions />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Contents/New/Editor.js